export const suggestionFormFields = {
  suggestion: 'suggestion',
}
